import "./style.css";
import { Post } from "../../../../types";
import { Paperclip } from "react-feather";
import axios from "axios";
import { useState } from "react";
import { useMessage } from "../../../../global-components/src";
import { useAuth } from "../../../../global-components/src";
import { errorMessage } from "../../../../utils/TextManagerTwo";
import { PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { authId } from "../../../../global-components/src/utils/auth";
import { useTranslation } from "react-i18next";

interface PostProps{
    post: Post
}

const PinPost: React.FC<PostProps> = ({ post }) => {
    const [error, setError] = useState("");
    const [isPin, setiIsPin] = useState(post?.user?.pinned_post_id === post?.id);
    const { setMessage } = useMessage();
    const { isAuthenticated, token } = useAuth();
    const { t } = useTranslation();

    const handlePinPost = async() =>{
        try {
            const url = PACOCA_API_URL + "/posts/" + (isPin ? "unpin/" : "pin/") + post?.id;
            post.user.pinned_post_id = isPin ? 0 : post?.id

            await axios.post(url, {
                id_post: post?.id
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })

            setiIsPin(!isPin)
            setMessage(isPin ? t("post.unpinned") : t("post.pinned"), 'success');

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
            console.error('Erro:', messageError);
        }
        
    }

    return (
        <>
        {isAuthenticated && post?.user?.id === authId() ? (
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={handlePinPost}>
                    <div className="div-icon-fix">
                        {isPin ? (
                            <><Paperclip data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("post.actions.unpinFromProfile")}</>
                        ) : (
                            <><Paperclip data-feather="paperclip" data-type="fix" className="icon-config-post"/>{t("post.actions.pinToProfile")}</>
                        )}
                    </div> 
                </span>
            </li>
        ) : null}
        
        </>
    );
};

export default PinPost;
